import React from 'react';

import NextHead from 'next/head';

type PageTitleProps = {
  title: string;
};

function PageTitle({ title }: PageTitleProps) {
  return (
    <NextHead>
      <title>{title}</title>
    </NextHead>
  );
}

export default PageTitle;
